"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.weightedMod11 = exports.diffInYears = exports.testDate = exports.compareAsc = void 0;
/**
 * Compare the two dates and return -1, 0 or 1.
 */
function compareAsc(dateLeft, dateRight) {
    const diff = dateLeft.getTime() - dateRight.getTime();
    return diff < 0 ? -1 : diff > 0 ? 1 : diff;
}
exports.compareAsc = compareAsc;
/**
 * Test if the input parameters are a valid date or not.
 */
function testDate(year, month, day) {
    month -= 1;
    const date = new Date(year, month, day);
    return !(date.getFullYear() !== year ||
        date.getMonth() !== month ||
        date.getDate() !== day);
}
exports.testDate = testDate;
/**
 * Get the number of full years between the given dates.
 */
function diffInYears(dateLeft, dateRight) {
    const sign = compareAsc(dateLeft, dateRight);
    const yearDiff = Math.abs(dateLeft.getFullYear() - dateRight.getFullYear());
    dateLeft.setFullYear(dateLeft.getFullYear() - sign * yearDiff);
    const isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
    const result = sign * (yearDiff - +isLastYearNotFull);
    return result === 0 ? 0 : result;
}
exports.diffInYears = diffInYears;
/**
 * Calculates the mod 11 checksum of the given digits based on the provided weights.
 * Source: https://no.wikipedia.org/wiki/F%C3%B8dselsnummer
 * Numbers with rest 10 is discarded on generation and therefore not considered
 */
function weightedMod11(str, weights) {
    let sum = 0;
    for (let idx = 0; idx < weights.length; idx++) {
        sum += parseInt(str[idx], 10) * weights[idx];
    }
    const rest = sum % 11;
    return rest === 0 ? 0 : 11 - rest;
}
exports.weightedMod11 = weightedMod11;
//# sourceMappingURL=utils.js.map